import React from "react";
import Carousel from "../../atoms/carousel";
import styles from "./styles.m.css";
import ResponsiveImageWithFallback from "../../atoms/responsive-image-with-fallback";
import { Icon } from "../../atoms/icon";
import PropTypes from "prop-types";
import { DfpAd } from "../../atoms/dfp-ad";

const PhotoAlbumImage = ({ storyElement, count, index }) => {
  return (
    <div className={"container"}>
      <div className={styles["image-container"]}>
        <div className={styles["slide-counter"]}>{`${index}/${count}`}</div>
        <ResponsiveImageWithFallback
          className={styles["image-container-figure"]}
          slug={storyElement["image-s3-key"]}
          metadata={storyElement["image-metadata"]}
          alt={storyElement["image-caption"]}
          imgParams={{ auto: ["format", "compress"] }}
          sources={[
            {
              defaultWidth: 500,
              widths: [500, 700, 900, 1200],
              sizes: "(min-width: 768px) 50vw"
            },
            {
              defaultWidth: 200,
              widths: [200, 360, 700],
              sizes: "(max-width: 768px) 98vw"
            }
          ]}
        />
      </div>
      {storyElement["title"] && (
        <div className={styles["text-wrapper"]}>
          <h3 className={styles["image-caption"]}>{storyElement["title"]} </h3>
        </div>
      )}
    </div>
  );
};

PhotoAlbumImage.propTypes = {
  storyElement: PropTypes.shape({
    "image-s3-key": PropTypes.string,
    "image-metadata": PropTypes.object,
    "image-caption": PropTypes.string,
    title: PropTypes.string
  }),
  count: PropTypes.number,
  index: PropTypes.number
};

const PhotoAlbumSlider = ({ imageElements, type, className = "", onSlideChange: onSlideChangeProp }) => {
  function onSlideChange(index) {
    if (!onSlideChangeProp) {
      return;
    }
    if (type === "gallery") {
      onSlideChangeProp(index - Math.floor((index + 1) / 5)); // take into account the ads that are added below
    } else {
      onSlideChangeProp(index);
    }
  }
  let galleryElements = imageElements.map((e, idx) => (
    <PhotoAlbumImage storyElement={e} index={idx + 1} count={imageElements.length} key={e.id} />
  ));
  if (type === "gallery") {
    let copyGalleryElements = [];
    for (let idx in galleryElements) {
      if (parseInt(idx, 10) > 0 && parseInt(idx, 10) % 4 === 0) {
        copyGalleryElements.push(<DfpAd className={`${styles.ad}`} adtype="Rectangle" placement="gallery" />);
      }
      copyGalleryElements.push(galleryElements[idx]);
    }
    galleryElements = copyGalleryElements;
  }

  return galleryElements.length > 0 ? (
    <div className={`${styles["album-container"]} ${className}`}>
      <div className={styles["slider-wrapper"]}>
        <Carousel
          className="photo-album"
          options={{
            type: "carousel",
            autoplay: false,
            perView: 1,
            classes: {
              activeSlide: styles["is-card-active"]
            }
          }}
          afterSlide={onSlideChange}
          renderCenterLeftControls={({ previousSlide }) => (
            <button
              aria-label="previous slide"
              role="button"
              onClick={previousSlide}
              className={`${styles["slider-nav-button"]}`}
            >
              <Icon type="line-arrow-prev" className={styles["prev-arrow"]} />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button
              aria-label="next slide"
              role="button"
              onClick={nextSlide}
              className={`${styles["slider-nav-button"]}`}
            >
              <Icon type="line-arrow-next" className={styles["next-arrow"]} />
            </button>
          )}
        >
          {galleryElements}
        </Carousel>
      </div>
    </div>
  ) : null;
};

PhotoAlbumSlider.propTypes = {
  imageElements: PropTypes.arrayOf(PropTypes.shape(PhotoAlbumImage.propTypes.storyElement)),
  type: PropTypes.string,
  className: PropTypes.string,
  onSlideChange: PropTypes.func
};

const PhotoAlbum = ({ storyElement, onSlideChange }) => {
  if (!storyElement) {
    return null;
  }

  return (
    <PhotoAlbumSlider
      imageElements={storyElement["story-elements"]}
      type={storyElement["metadata"]["type"]}
      onSlideChange={onSlideChange}
    />
  );
};

PhotoAlbum.propTypes = {
  storyElement: PropTypes.shape({
    "story-elements": PropTypes.arrayOf(PropTypes.shape(PhotoAlbumImage.propTypes.storyElement))
  }),
  onSlideChange: PropTypes.func
};

export default PhotoAlbum;

export { PhotoAlbumSlider };
